import React, { useState } from 'react'
import ManualRegistration from '../sections/ManualRegistration'
import { postRegistrations } from '../services/dashboard.service'
import { toast } from 'react-toastify'
import { getApiErrorMessage } from '../utils/error'
import FloatCard from '../components/Card/FloatCard'
import TextInput from '../components/Input/TextInput'
import FileInput from '../components/Input/FileInput'

const RenewRegistration = () => {
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (e) => {
    try {
      setIsLoading(true)

      e.preventDefault()
      const data = new FormData(e.target)
      if (!data.get('profileImage')) {
        alert('Foto profil harus diisi')
        return
      }
      if (!data.get('ktpImage')) {
        alert('Foto KTP harus diisi')
        return
      }
      data.set('type', 'MANUAL RENEW')
      data.append('files', data.get('ktpImage'))
      data.delete('ktpImage')
      data.append('files', data.get('profileImage'))
      data.delete('profileImage')
      data.append('files', data.get('oldKtaImage'))
      data.delete('oldKtaImage')

      await postRegistrations(data)
      toast.success('Berhasil registrasi')
      setTimeout(() => {
        window.location.href = '/'
      }, 400)
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Gagal menyimpan registrasi'))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ManualRegistration
      onSubmit={onSubmit}
      title="Pembaruan KTA"
      isLoading={isLoading}
    >
      <FloatCard>
        <div className="p-4 mt-4">
          <h2 className="text-lg font-semibold">Data Perpanjangan KTA</h2>
          <p className="text-[#77787A] text-sm">
            Upload dokumen pendukung berupa <b>Kartu Tanda Anggota (KTA)</b>{' '}
            yang masih aktif untuk mendaftarkan KTA Jakmania kamu.
          </p>
          <TextInput
            label="NOMOR KTA JAKMANIA SEBELUMNYA"
            placeholder="Masukkan Nomor KTA Jakmania"
            labelBottomLeft="Nomor unik pada KTA sebelumnya"
            type="text"
            name="oldKtaNumber"
            required={true}
          />
          <FileInput
            name="oldKtaImage"
            label="UPLOAD KTA"
            placeholder="Upload KTA Sebelumnya"
            labelBottomLeft="Upload maks. 5MB dengan format PDF, JPG, atau PNG"
          />
        </div>
      </FloatCard>
    </ManualRegistration>
  )
}

export default RenewRegistration
